export default __webpack_public_path__ + "static/media/HRA.0411a377.svg";